<div fxLayout="column">
  <div fxFlex fxLayout="row" *ngIf="hasFilter" fxLayoutGap="10">
    <div fxFlex class="search-input">
      <mat-form-field *ngIf="!hideFilter">
        <input
          matInput
          #input
          (keyup)="applyFilter(filterValue)"
          [(ngModel)]="filterValue"
          (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
          (onModelChange)="keyboardService.onInputChange($event, input)"
          placeholder="Pesquisar" />
      </mat-form-field>
    </div>
    <div fxFlex="initial" *ngIf="hasAdd">
      <button mat-fab class="btn-add" (click)="openNew.emit()">
        <mat-icon
          aria-label="Example icon-button with a heart icon">add</mat-icon>
      </button>
    </div>
  </div>
  <div class="mat-elevation-z8" class="mat-elevation-z8">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
        <!-- Checkbox Column -->
        <ng-container *ngIf="hasSelectConfig()" matColumnDef="select" sticky>
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (click)="onCheckRow($event)"
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-checkbox
              (click)="onCheckRow($event, i)"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- Position Column -->
        <ng-container
          *ngFor="let config of configColumns; let idx = index"
          matColumnDef="{{ config.property }}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ config.display }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="{{ config.class }} td_idx_{{ idx }}"
            [attr.data-label]="config.display">
            <a
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY) &&
                config.link_show
              "
              href="javascript:void()"
              (click)="openShow.emit(element)"
              class="disabled_link_on_web {{ activeShowLockClass(element) }}">
              {{ getValue(config, element[config.property]) }}
            </a>
            <!-- LABEL COMUM -->
            <ng-container
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY) &&
                !config.link_show
              "
              class="{{ activeShowLockClass(element) }}">{{ getValue(config,
              element[config.property]) }}</ng-container>
            <!-- LABEL FLAG -->
            <ng-container
              *ngIf="config.field_type === fieldTypeEnum.LABEL_FLAG">
              <mat-icon class="check-icon"
                *ngIf="element[config.property]">check</mat-icon>
            </ng-container>

            <ng-container *ngIf="config.field_type === fieldTypeEnum.IMAGE">
              <img
                class="image-label"
                [src]="getUrl(element[config.property])" />
            </ng-container>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let row = index">
            <button mat-icon-button
              *ngIf="element.typeQuestion !== 'REUNIAO' && element.typeQuestion !== 'BRIEFING'">
              <mat-icon
                class="btn-link"
                (click)="navigateToEvent(element)">
                link
              </mat-icon>
            </button>

            <button mat-icon-button *ngIf="element.typeQuestion === 'REUNIAO'">
              <mat-icon
                class="btn-link"
                (click)="navigateToMeeting(element)">
                group
              </mat-icon>
            </button>

            <button mat-icon-button *ngIf="element.typeQuestion === 'BRIEFING'">
              <mat-icon
                class="btn-link"
                (click)="navigateToBriefing(element)">
                description
              </mat-icon>
            </button>

            <button mat-icon-button *ngIf="!element.hideQrCode">
              <mat-icon class="btn-qr-code"
                (click)="qrCodeRow(element, row)">qr_code
              </mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" >
            <mat-icon>more_vert</mat-icon>
              </button>
            <mat-menu #menu="matMenu">  
              <button mat-menu-item *ngIf="!element.hideShow" (click)="showRow(element, row)">
                <mat-icon class="btn-show" >
                  remove_red_eye
                </mat-icon>
                <span>Visualizar</span>
              </button>

              <button mat-menu-item *ngIf="!element.hideShow" (click)="editRow(element, row)">
                <mat-icon class="btn-edit" >
                  edit
                </mat-icon>
                <span>Editar</span>
              </button>

              <button mat-menu-item *ngIf="!element.hideDelete" (click)="deleteRow(element, row)" class="btn-delete">
                <mat-icon class="btn-delete"
                  >delete</mat-icon>
                  <span>Deletar</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            &nbsp;
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              aria-label="expand row"
              (click)="
                expandedElement = expandedElement === element ? null : element;
                $event.stopPropagation()
              ">
              <mat-icon
                *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
              <mat-icon
                *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
            <div
              class="example-element-detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              ">
              <ng-template
                *ngTemplateOutlet="templateRef; context: { rawData: element }"></ng-template>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onSelect.emit({ select: true, row })"
          [ngClass]="
            typeIndexEnum.SELECT === type ? 'cursor-pointer' : 'cursor-normal'
          "></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"></tr>
      </table>
    </div>

    <mat-paginator
      *ngIf="!hidePagination"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent($event)"></mat-paginator>

  </div>
</div>
